import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type BlockchainAddressWithId = {
  idBlockchainAddress: number;
};

// Базовый тип для общих полей адреса блокчейна
type BlockchainAddressCommonFields = {
  idBlockchain: number;
  formatName: string;
  prefix: string;
  regexPattern: string;
  minLength: number;
  maxLength: number;
  checksumAlgorithm: string;
  hasMemoTag: boolean;
  description: string;
};

// Типы для WebSocket сообщений компонента blockchainAddresses
type BlockchainAddressesListMessage = WebSocketMessageWithFields<'helper-wallets' | 'blockchain-address-list', {
  blockchainAddresses: unknown[];
}>;
type BlockchainAddressCreateMessage = WebSocketMessageWithFields<'blockchain-address-create' | 'blockchain-address-create-success', BlockchainAddressWithId & BlockchainAddressCommonFields & {
  locked: boolean;
}>;
type BlockchainAddressUpdateMessage = WebSocketMessageWithFields<'blockchain-address-update' | 'blockchain-address-update-success', BlockchainAddressWithId & BlockchainAddressCommonFields>;
type BlockchainAddressDeleteMessage = WebSocketMessageWithFields<'blockchain-address-delete' | 'blockchain-address-delete-success', BlockchainAddressWithId>;
type BlockchainAddressLockMessage = WebSocketMessageWithFields<'blockchain-address-lock' | 'blockchain-address-lock-success', BlockchainAddressWithId>;
type BlockchainAddressUnlockMessage = WebSocketMessageWithFields<'blockchain-address-unlock' | 'blockchain-address-unlock-success', BlockchainAddressWithId>;

// Объединенный тип для всех сообщений
type BlockchainAddressesWebSocketMessage = 
  | BlockchainAddressesListMessage 
  | BlockchainAddressCreateMessage 
  | BlockchainAddressUpdateMessage 
  | BlockchainAddressDeleteMessage 
  | BlockchainAddressLockMessage 
  | BlockchainAddressUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataBlockchainAddresses',
},
  __name: 'blockchainAddresses',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID адреса блокчейна
const handleWebSocketMessage = (data: BlockchainAddressesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'helper-wallets':
    case 'blockchain-address-list':
      store.dispatch('blockchainAddresses/wsSetBlockchainAddresses', {blockchainAddresses: data.blockchainAddresses});
      break;

    case 'blockchain-address-create':
    case 'blockchain-address-create-success':
      store.dispatch('blockchainAddresses/wsBlockchainAddressCreate', {
        idBlockchainAddress: data.idBlockchainAddress,
        idBlockchain: data.idBlockchain,
        formatName: data.formatName,
        prefix: data.prefix,
        regexPattern: data.regexPattern,
        minLength: data.minLength,
        maxLength: data.maxLength,
        checksumAlgorithm: data.checksumAlgorithm,
        hasMemoTag: data.hasMemoTag,
        description: data.description,
        locked: data.locked,
      });
      break;

    case 'blockchain-address-update':
    case 'blockchain-address-update-success':
      store.dispatch('blockchainAddresses/wsBlockchainAddressUpdate', {
        idBlockchainAddress: data.idBlockchainAddress,
        idBlockchain: data.idBlockchain,
        formatName: data.formatName,
        prefix: data.prefix,
        regexPattern: data.regexPattern,
        minLength: data.minLength,
        maxLength: data.maxLength,
        checksumAlgorithm: data.checksumAlgorithm,
        hasMemoTag: data.hasMemoTag,
        description: data.description,
      });
      break;

    case 'blockchain-address-delete':
    case 'blockchain-address-delete-success':
      store.dispatch('blockchainAddresses/wsBlockchainAddressDelete', {
        idBlockchainAddress: data.idBlockchainAddress,
      });
      break;

    case 'blockchain-address-lock':
    case 'blockchain-address-lock-success':
      store.dispatch('blockchainAddresses/wsBlockchainAddressLock', {
        idBlockchainAddress: data.idBlockchainAddress,
      });
      break;

    case 'blockchain-address-unlock':
    case 'blockchain-address-unlock-success':
      store.dispatch('blockchainAddresses/wsBlockchainAddressUnlock', {
        idBlockchainAddress: data.idBlockchainAddress,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})